import HorizontalGridLabels from "../Pulsar/components/HorizontalGridLabels";
import HorizontalGrid from "../Pulsar/components/HorizontalGrid";
import FilterContainer from "../Pulsar/components/Filters/FilterContainer";
import dnaOverlay from "../Pulsar/tracks/dna/DnaOverlay";
import dnaTrackController from "../Pulsar/tracks/dna/dnaTrackController";
import dellyCnvTrackController from "../Pulsar/tracks/dellyCnvCalls/dellyCnvTrackController";
import DellyCnvTooltip from "../Pulsar/tracks/dellyCnvCalls/components/CnvDellyTooltip";
import DellyCnvTitle from "../Pulsar/tracks/dellyCnvCalls/components/CnvDellyTitle";

import dellyCoverageTrackController from "../Pulsar/tracks/dellyCoverage/dellyCoverageTrackController";
import DellyCoverageOverlay from "../Pulsar/tracks/dellyCoverage/DellyCoverageOverlay";
import getApiClient from "../Pulsar/apiClient";

import selectionTrackController from "../Pulsar/tracks/selection/selectionTrackController";
import RohTitle from "../Pulsar/tracks/roh/components/RohTitle";
import RohTooltip from "../Pulsar/tracks/roh/components/RohTooltip";
import rohTrackController from "../Pulsar/tracks/roh/rohTrackController";

// Transcripts
import transcriptTrackController from "../Pulsar/tracks/transcripts/transcriptTrackController";
import TranscriptTooltip from "../Pulsar/tracks/transcripts/components/TranscriptTooltip";
import TranscriptsOverlay from "../Pulsar/tracks/transcripts/components/TranscriptsOverlay";
import TranscriptInfo from "../Pulsar/tracks/transcripts/components/TranscriptInfo";

function getCnvBrowserTracks(sampleId) {
  const {
    loadSequence,
    loadDellyCnvCalls,
    loadDellyCoverage,
    loadMainTranscripts,
    getRohBedFile,
  } = getApiClient();

  const tracks = [
    {
      id: "delly-dna",
      title: "Dna",
      contentHeight: 25,
      pTop: 0,
      pBottom: 0,
      headerHeight: 0,
      isStickyTop: true,
      OverlayRenderer: dnaOverlay,
      controller: dnaTrackController,
      apiLoader: {
        apiFn: loadSequence,
        maxRange: 10000,
      },
    },
    {
      id: "delly-roh-sample",
      title: "Runs of Homozygosity",
      data: {
        sample: {
          id: sampleId,
        },
      },
      contentHeight: 24,
      pTop: 2,
      pBottom: 2,
      TitleRenderer: RohTitle,
      TooltipRenderer: RohTooltip,
      controller: rohTrackController,
      apiLoader: {
        apiFn: getRohBedFile,
        maxRange: Infinity,
      },
    },

    {
      id: "delly-cnv-calls",
      title: "CNV calls",
      contentHeight: 160,
      pTop: 18,
      pBottom: 18,
      FilterRenderer: FilterContainer,
      GridRenderer: HorizontalGrid,
      AxisRenderer: HorizontalGridLabels,
      TitleRenderer: DellyCnvTitle,
      TooltipRenderer: DellyCnvTooltip,
      controller: dellyCnvTrackController,
      apiLoader: {
        apiFn: loadDellyCnvCalls,
        maxRange: Infinity,
      },
    },
    {
      id: "coverage-delly",
      title: "Coverage",
      contentHeight: 120,
      pTop: 15,
      pBottom: 5,
      controller: dellyCoverageTrackController,
      AxisRenderer: HorizontalGridLabels,
      GridRenderer: HorizontalGrid,
      FilterRenderer: FilterContainer,
      OverlayRenderer: DellyCoverageOverlay,
      apiLoader: {
        apiFn: loadDellyCoverage,
        maxRange: 300000,
      },
    },
    {
      id: "delly-transcript-gene",
      title: "Transcripts",
      contentHeight: 0,
      pTop: 8,
      pBottom: 8,
      FilterRenderer: FilterContainer,
      TooltipRenderer: TranscriptTooltip,
      TitleRenderer: TranscriptInfo,
      OverlayRenderer: TranscriptsOverlay,
      controller: transcriptTrackController,
      apiLoader: {
        apiFn: loadMainTranscripts,
        maxRange: Infinity,
      },
    },
    {
      id: "delly-btm",
      contentHeight: 400,
      headerHeight: 0,
      controller: () => ({ onReset: () => {}, meshes: [] }),
    },
    {
      id: "overlay-cnv",
      title: "overlay",
      headerHeight: 20,
      isOverlay: true,
      contentHeight: 200,
      pTop: 0,
      pBottom: 0,
      controller: selectionTrackController,
    },
  ];

  return tracks;
}

export default getCnvBrowserTracks;
